import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'https://ifmo.zko.com.pl/api';
const REFRESH_URL = `${API_URL}/token/refresh/`;

const api = axios.create({
  baseURL: API_URL,
});



api.interceptors.request.use(
  async (config) => {
    const accessToken = sessionStorage.getItem('access_token');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const requestUrl = originalRequest?.url || '';

    if (error.response && error.response.status === 401 && requestUrl.startsWith('/kiosk/')) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true; // Zapobiega pętli odświeżania tokena

      try {
        // Próba odświeżenia tokena
        const refreshToken = sessionStorage.getItem('refresh_token');
        if (!refreshToken) {
          throw new Error('Brak refresh tokena');
        }

        // Wysyłanie żądania o nowy token
        const refreshResponse = await axios.post(REFRESH_URL, { refresh: refreshToken });
        const newAccessToken = refreshResponse.data.access;
        const newRefreshToken = refreshResponse.data.refresh;

        // Zapisz nowy token do sessionStorage
        sessionStorage.setItem('access_token', newAccessToken);
        sessionStorage.setItem('refresh_token', newRefreshToken);

        // Ustaw nowy token w nagłówkach oryginalnego żądania
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

        // Powtórz oryginalne żądanie z nowym tokenem
        return api(originalRequest);
      } catch (refreshError) {
        // Logowanie błędu odświeżania tokena
        console.error('Błąd odświeżania tokena:', refreshError);

        // Usunięcie tokenów i przekierowanie na stronę logowania
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('refresh_token');
        window.location.href = '/login'; // Przekierowanie do logowania
      }
    }

    // Przechwytywanie innych błędów, które nie są związane z 401
    return Promise.reject(error);
  }
);



export default api;
